import { render } from "./WindowButtonsMac.vue?vue&type=template&id=72b066be&ts=true"
import script from "./WindowButtonsMac.vue?vue&type=script&lang=ts"
export * from "./WindowButtonsMac.vue?vue&type=script&lang=ts"

import "./WindowButtonsMac.vue?vue&type=style&index=0&id=72b066be&lang=scss"

import exportComponent from "/Users/colin/Documents/FUSE/code/live/fusestudio.net/Graphite/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__